<div class="contact-wrapper" [title]="shortContactDescription">
    <div class="contact-image" [ngStyle]="{ background: exampleThemeColor ? exampleThemeColor : themeColor }">
        <div class="contact-image-inner">{{ contact.name | contactInitials }}</div>
    </div>
    <div>
        <div class="contact-title"><span *ngIf="isHCAT" class="icon-triflame"></span> {{ contact.title }}</div>
        <div class="contact-name">{{ contact.name }}</div>
        <div class="contact-email-wrapper">
            <a class="contact-email" [href]="'mailto:' + contact.email">{{ contact.email }}</a>
        </div>
    </div>
</div>
